"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.YandexMap = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactYandexMaps = require("@pbe/react-yandex-maps");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const MapContainer = (0, _mui.styled)('div')(() => ({
  width: '100%',
  height: '100%'
}));
const YandexInner = props => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [mapRef, isClusteredPickupPointsListLoading, isYandexApiLoaded] = (0, _hooks.useYandexMap)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!isYandexApiLoaded && !isClusteredPickupPointsListLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: "Yandex maps cannot be loaded."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(MapContainer, {
      ref: mapRef,
      "data-testid": getTestId(_models.TestId.YandexMapContainer)
    })]
  });
};
const YandexMap = props => {
  const {
    account
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactYandexMaps.YMaps, {
    query: {
      apikey: account.credentials
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(YandexInner, {
      ...props
    })
  });
};
exports.YandexMap = YandexMap;
var _default = exports.default = YandexMap;